export function getToolCallId(params: unknown): string {
  if (!params || typeof params !== 'object') return '';
  const u = params as Record<string, unknown>;
  const id = u.toolCallId ?? u.tool_call_id;
  return typeof id === 'string' ? id : '';
}

export function isCompletedToolStatus(status: unknown): boolean {
  if (typeof status !== 'string') return false;
  const s = status.toLowerCase();
  return s === 'completed' || s === 'complete' || s === 'succeeded' || s === 'success';
}

export function isFailedToolStatus(status: unknown): boolean {
  if (typeof status !== 'string') return false;
  const s = status.toLowerCase();
  return s === 'failed' || s === 'error' || s === 'cancelled' || s === 'canceled';
}

export function accumulateToolPaths(toolKey: string, paths: string[], acc: Map<string, Set<string>>): void {
  if (!toolKey || paths.length === 0) return;
  let s = acc.get(toolKey);
  if (!s) {
    s = new Set();
    acc.set(toolKey, s);
  }
  for (const p of paths) s.add(p);
}
